"use strict";

exports.__esModule = true;
exports.KeyTimeout = void 0;
var KeyTimeout = exports.KeyTimeout = /*#__PURE__*/function () {
  function KeyTimeout() {
    this.timeoutHandleForKey = {};
  }
  var _proto = KeyTimeout.prototype;
  _proto.clearTimeout = function (_clearTimeout) {
    function clearTimeout(_x) {
      return _clearTimeout.apply(this, arguments);
    }
    clearTimeout.toString = function () {
      return _clearTimeout.toString();
    };
    return clearTimeout;
  }(function (key) {
    clearTimeout(this.timeoutHandleForKey[key]);
  });
  _proto.updateTimeout = function updateTimeout(key, durationMs, callback) {
    this.clearTimeout(key);
    this.timeoutHandleForKey[key] = setTimeout(function () {
      callback();
    }, durationMs);
  };
  return KeyTimeout;
}();